import { consultFormService, consultHistoryService } from '../_services';
import { indexedDB } from '../_helpers';

function newConsultSteps () {
  return Object.assign({}, {
    'ClientDetails': {
      title: 'Client Details',
      visited: true,
      complete: false,
      dependsOn: [],
    },
    'CurrentMastitisSituation': {
      title: 'Current Mastitis Situation',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'MastitisGoals': {
      title: 'Mastitis Goals',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'MastitisControlMeasures': {
      title: 'Mastitis Control Measures',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'CowEnvironment': {
      title: 'Cow Environment',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'DryCowStrategy': {
      title: 'Drycow Strategy',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'PreventiveHealthAndVacination': {
      title: 'Preventive Health And Vaccination',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'DryOffProcess': {
      title: 'Dry-Off Process',
      visited: false,
      complete: false,
      dependsOn: [],
      requiredFields: ['wants_vs_application'],
    },
    'ThisSeasonDryOff': {
      title: 'This Season Dry-Off',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'DryCowAndTeatsealOrder': {
      title: 'Dry Cow And Teatseal Order',
      visited: false,
      complete: false,
      dependsOn: [],
    },
    'EmailNotifications': {
      title: 'Email Notifications',
      dependsOn: [],
      visited: false,
      complete: false,
    },
    'Disclaimer': {
      title: 'Disclaimer Page',
      dependsOn: ['__all__',],
      visited: false,
      complete: false,
    },
  })
}

const state = {
  version: '0.6.7',
  client: null,
  currentIndex: 0,
  consultSteps: newConsultSteps(),
  models: {},
  backendErrors: {},
  dbName: 'dry-cow-consult',
  endpoints: {
    'get': '/clients/{client}/dry_cow_consult/{season}',
    'post': '/clients/{client}/dry_cow_consult/save',
  },
};


const actions = {
  saveConsultData({ commit, state }, {clientId, season}) {
    let endpoint = state.endpoints.post
      .replace('{client}', clientId)
      .replace('{season}', season)

    return indexedDB.get(clientId, state.dbName).then(consultData => {
      return consultFormService.saveClientConsultData(consultData.models, endpoint)
        .catch(
          error => {
            // return dispatch('addBackendErrors', {clientId: state.client, errors: error.response.data})
            if (error.response.status == 400) {
              commit('addBackendErrors', error.response.data)
            }
            return Promise.reject(error)
          },
        )
    })
  },
  getReadOnlyData({ commit, state, }, consultParams) {
      let endpoint = state.endpoints.get
          .replace('{client}', consultParams.clientId)
          .replace('{season}', consultParams.season)
      return consultHistoryService.getConsultHistoryData(endpoint)
        .then(
          models => {
            commit('resetConsultSteps', newConsultSteps())
            commit('setClient', consultParams.clientId);
            models.Misc.read_only = true
            commit('setModels', models);

          },
          error => {
            return Promise.reject(error)
          }
        );
  },
  getConsultData({ commit, dispatch, state }, {clientId, season}) {

    return indexedDB.get(state.client, state.dbName).then(consultState => {

      if (consultState && consultState.version === state.version) {
        commit('resetConsultSteps', consultState.consultSteps)
        commit('setModels', consultState.models);
        commit('updateStateFromIDB', consultState)
      } else {
        let endpoint = state.endpoints.get
              .replace('{client}', clientId)
              .replace('{season}', season)

        return consultFormService.getClientConsultData(endpoint)
          .then(
            models => {
              commit('setClient', clientId);
              if (models.Misc.consult_state == 'finished') {
                models.Misc.consult_state = 'initial'
                let consultSteps = newConsultSteps()

                for (let stepSlug of Object.keys(consultSteps))
                {
                  consultSteps[stepSlug].complete = true
                  delete consultSteps[stepSlug].requiredFields
                }

                commit('resetConsultSteps', consultSteps)
              } else {
                commit('resetConsultSteps', newConsultSteps())
              }
              commit('setModels', models);
              dispatch('backupState', {models})
            },
            error => {
              return Promise.reject(error)
            }
          );
      }
    })
  },
  toggleNotification({ commit }, {slug, value}) {
    commit('toggleNotification', {slug, value})
  },
}

const mutations = {
  toggleNotification(state, {slug, value}) {
    let notifications = state.models['EmailNotifications'].notifications

    let notification = notifications.find((item) => item.slug == slug)
    if (notification) {
      notification.marked = value
    }
  },
}

const getters = {
  freeOtherAnimals: function(state) {
    let NON_HERD_DCO = state.models.DryCowAndTeatsealOrder.NON_HERD_DCO
    let NEW_NON_HERD_DCO = state.models.DryCowAndTeatsealOrder.NEW_NON_HERD_DCO

    let allUsedAnimalsIds = Object.keys(NON_HERD_DCO)
			.filter((key) => NON_HERD_DCO[key].delete != true)
      .map((key) => NON_HERD_DCO[key].animal_ezyvet_id)
      .concat(Object.keys(NEW_NON_HERD_DCO).map((key) => NEW_NON_HERD_DCO[key].animal_ezyvet_id))

    return state.models.DryCowAndTeatsealOrder.OTHER_ANIMALS.filter((animal) => {
      return !allUsedAnimalsIds.includes(animal.animal_ezyvet_id)
    })
  },
  hasFreeOtherAnimals: function(_, getters) {
    return getters.freeOtherAnimals.length > 0
  },
}

export default {
  stateMixin: state,
  actionsMixin: actions,
  mutationsMixin: mutations,
  gettersMixin: getters,
};
